import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=79da3c79&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=79da3c79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79da3c79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79da3c79')) {
      api.createRecord('79da3c79', component.options)
    } else {
      api.reload('79da3c79', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=79da3c79&scoped=true&", function () {
      api.rerender('79da3c79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/repair/repairManagement/detail.vue"
export default component.exports